import { t } from "@lingui/macro";

export interface AccountDetails {
    id: string
    firstName: string | null
    lastName: string | null
    address: string | null
    city: string | null
    province: string | null
    postalCode: string | null
    country: string | null
    phone: string | null
    vatCode: string | null
    fiscalCode: string | null
}

export interface Account {
    id: string
    username: string
    disabled: boolean
    creationDate: string
    lastLogin: string
    accountType: AccountType
    accountDetails: AccountDetails | null
}

export interface Profile {
    accountDetails: ProfileDetails
    id: string,
    username: string
    disabled: boolean
    creationDate: string
    lastLogin: string | null
    accountType: string
}

interface ProfileDetails {
    id: string,
    firstName: string
    lastName: string
    address: string
    city: string
    province: string
    postalCode: string
    country: string
    phone: string
    vatCode: string
    fiscalCode: string
}

export interface UpdateProfileDetails {
    username: string
    accountType: string
    firstName: string
    lastName: string
    address: string
    city: string
    province: string
    postalCode: string
    country: string
    phone: string
    vatCode: string
    fiscalCode: string
}

export enum AccountType {
    LANDLORD = "LANDLORD",
    BRAND = "BRAND",
    ADMIN = "ADMIN",
    MICROJOB = "MICROJOB",
}

export enum LandLordType {
    OWNER = "OWNER",
    PRIVATE_SUBTENANT = "PRIVATE_SUBTENANT",
    COMPANY_SUBTENANT = "COMPANY_SUBTENANT",
    ESTATE_AGENCY = "ESTATE_AGENCY",
    DEVELOPMENT_COMPANY = "DEVELOPMENT_COMPANY",
    BANK = "BANK",
    ESTATE_FUND = "ESTATE_FUND",
    ASSOCIATION = "ASSOCIATION",
    PUBLIC_AUTHORITY = "PUBLIC_AUTHORITY"
}

class LandLordTypeTranslations {
    OWNER = t({ id: "enums.landlord-type.OWNER", message: "Proprietario" })
    PRIVATE_SUBTENANT = t({ id: "enums.landlord-type.PRIVATE_SUBTENANT", message: "Affittuario (Privato)" })
    COMPANY_SUBTENANT = t({ id: "enums.landlord-type.COMPANY_SUBTENANT", message: "Affittuario (Azienda)" })
    ESTATE_AGENCY = t({ id: "enums.landlord-type.ESTATE_AGENCY", message: "Agenzia Immobiliare" })
    DEVELOPMENT_COMPANY = t({ id: "enums.landlord-type.DEVELOPMENT_COMPANY", message: "Agenzia di Sviluppo Immobiliare" })
    ASSOCIATION = t({ id: "enums.landlord-type.ASSOCIATION", message: "Associazione" })
    PUBLIC_AUTHORITY = t({ id: "enums.landlord-type.PUBLIC_AUTHORITY", message: "Pubblica Amministrazione" })
    ESTATE_FUND = t({ id: "enums.landlord-type.ESTATE_FUND", message: "Fondo immobiliare" })
    BANK = t({ id: "enums.landlord-type.BANK", message: "Banca" })
}


class AccountTypeTranslations {
    LANDLORD = t({ id: "enums.account-type.LANDLORD", message: "Proprietario" })
    BRAND = t({ id: "enums.account-type.BRAND", message: "Brand" })
    ADMIN = t({ id: "enums.account-type.ADMIN", message: "Amministratore" })
    MICROJOB = t({ id: "enums.account-type.MICROJOB", message: "Microjobber" })
}
